import React, { useEffect, useState } from 'react';

import queryString from 'query-string';

import { unsubscribe } from '../../api';

import './UnsubscribePage.scss';

type UnsubscribeState = 'pending' | 'success' | 'failure';

function getText(unsubscribeState: UnsubscribeState) {
    switch (unsubscribeState) {
        case 'pending':
            return '';
        case 'success':
            return 'Вы отписаны от всех уведомлений.';
        case 'failure':
            return 'Не получилось отписаться. Возможно, вы не авторизованы, или ссылка устарела.';
    }
}

export default function UnsubscribePage() {
    const [unsubscribeState, setUnsubscribeState] = useState<UnsubscribeState>('pending');
    useEffect(() => {
        const parsed = queryString.parse(location.search);

        if (!parsed.token) {
            return setUnsubscribeState('failure');
        }

        unsubscribe(parsed.token)
            .then(() => {
                setUnsubscribeState('success');
            })
            .catch((err) => {
                console.error(err);
                setUnsubscribeState('failure');
            });
    }, []);

    return <div className="unsubscribe-page">{getText(unsubscribeState)}</div>;
}
